export default __webpack_public_path__ + "static/media/state-detail-proveedor.4193586b.svg";